module.exports = __webpack_public_path__ + "img/quick-actions-empty.baf30933.png";